export enum AdminSettingCodesEnum {
  KNM_MATCH_EXPORT_DATE = 'KNM_MATCH_EXPORT_DATE',
  KNM_PLAN_MATCH_OUTPUT_DATE = 'KNM_PLAN_MATCH_OUTPUT_DATE',
  EXPORT_DOCUMENTS_KNO_DATE = 'EXPORT_DOCUMENTS_KNO_DATE',
  IMPORT_PLANS_DATE = 'IMPORT_PLANS_DATE',
  KNM_MANDATORY_DATES_STARTS_FROM = 'KNM_MANDATORY_DATES_STARTS_FROM',
  KNM_VALIDATION_4_1_1_STARTS_FROM = 'KNM_VALIDATION_4_1_1_STARTS_FROM',
  KNM_VALIDATION_223_4_1_2_STARTS_FROM = 'KNM_VALIDATION_223_4_1_2_STARTS_FROM',
  KNM_VALIDATION_4_1_4_STARTS_FROM = 'KNM_VALIDATION_4_1_4_STARTS_FROM',
  KNM_VALIDATION_223_4_1_16_STARTS_FROM = 'KNM_VALIDATION_223_4_1_16_STARTS_FROM',
  KNM_VALIDATION_523_4_1_41_STARTS_FROM = 'KNM_VALIDATION_523_4_1_41_STARTS_FROM',
  KNM_VALIDATION_223_4_1_14_STARTS_FROM = 'KNM_VALIDATION_223_4_1_14_STARTS_FROM',
  KNM_VALIDATION_223_4_1_42_STARTS_FROM = 'KNM_VALIDATION_223_4_1_42_STARTS_FROM',
  KNM_VALIDATION_4_1_19_STARTS_FROM = 'KNM_VALIDATION_4_1_19_STARTS_FROM',
  KNM_VALIDATION_4_1_19_ERVK_CHECK_LISTS_STARTS_FROM = 'KNM_VALIDATION_4_1_19_ERVK_CHECK_LISTS_STARTS_FROM',
  KNM_VALIDATION_4_1_21_STARTS_FROM = 'KNM_VALIDATION_4_1_21_STARTS_FROM',
  KNM_VALIDATION_4_1_21_CERT_STARTS_FROM = 'KNM_VALIDATION_4_1_21_CERT_STARTS_FROM',
  KNM_VALIDATION_4_1_22_STARTS_FROM = 'KNM_VALIDATION_4_1_22_STARTS_FROM',
  KNM_VALIDATION_4_1_23_STARTS_FROM = 'KNM_VALIDATION_4_1_23_STARTS_FROM',
  KNM_VALIDATION_4_1_25_STARTS_FROM = 'KNM_VALIDATION_4_1_25_STARTS_FROM',
  KNM_VALIDATION_4_1_26_STARTS_FROM = 'KNM_VALIDATION_4_1_26_STARTS_FROM',
  KNM_VALIDATION_4_1_27_STARTS_FROM = 'KNM_VALIDATION_4_1_27_STARTS_FROM',
  KNM_VALIDATION_4_1_28_STARTS_FROM = 'KNM_VALIDATION_4_1_28_STARTS_FROM',
  KNM_VALIDATION_4_1_31_STARTS_FROM = 'KNM_VALIDATION_4_1_31_STARTS_FROM',
  KNM_VALIDATION_4_1_35_STARTS_FROM = 'KNM_VALIDATION_4_1_35_STARTS_FROM',
  KNM_VALIDATION_4_1_36_STARTS_FROM = 'KNM_VALIDATION_4_1_36_STARTS_FROM',
  KNM_VALIDATION_4_1_42_STARTS_FROM = 'KNM_VALIDATION_4_1_42_STARTS_FROM',
  KNM_VALIDATION_4_1_43_STARTS_FROM = 'KNM_VALIDATION_4_1_43_STARTS_FROM',
  KNM_VALIDATION_4_1_52_STARTS_FROM = 'KNM_VALIDATION_4_1_52_STARTS_FROM',
  KNM_VALIDATION_4_1_54_STARTS_FROM = 'KNM_VALIDATION_4_1_54_STARTS_FROM',
  KNM_VALIDATION_4_1_55_STARTS_FROM = 'KNM_VALIDATION_4_1_55_STARTS_FROM',
  VALIDATION_4_1_29_STARTS_FROM = 'VALIDATION_4_1_29_STARTS_FROM',
  VALIDATION_4_1_39_STARTS_FROM = 'VALIDATION_4_1_39_STARTS_FROM',
  MAX_FILE_SIZE_MB = 'MAX_FILE_SIZE_MB',
  KNM_LOCK_TIME_4_1_31 = 'KNM_LOCK_TIME_4_1_31',
  USE_RISK_INDICATOR_SHORT_TITLE_STARTS_FROM = 'USE_RISK_INDICATOR_SHORT_TITLE_STARTS_FROM',
  PLAN_CONSIDERATION_LAST_DAY_OF_YEAR = 'PLAN_CONSIDERATION_LAST_DAY_OF_YEAR',
  ALLOWED_PLAN_IDS_FOR_UNDER_CONSIDERATION_STATUS = 'ALLOWED_PLAN_IDS_FOR_UNDER_CONSIDERATION_STATUS',
  ALLOWED_PLAN_IDS_FOR_APPROVED_STATUS = 'ALLOWED_PLAN_IDS_FOR_APPROVED_STATUS',
  REASON_FIELDS_AVAILABILITY_4_1_54_STARTS_FROM = 'REASON_FIELDS_AVAILABILITY_4_1_54_STARTS_FROM',
  KNM_REASON_4_1_54_STARTS_FROM = 'KNM_REASON_4_1_54_STARTS_FROM',
  LABEL_OF_APPROVE_REQUIRED_FIELD_4_1_2_STARTS_FROM = 'LABEL_OF_APPROVE_REQUIRED_FIELD_4_1_2_STARTS_FROM',
  VALIDATION_ACTION_START_DATE_IN_KNM_ACT_STARTS_FROM = 'VALIDATION_ACTION_START_DATE_IN_KNM_ACT_STARTS_FROM',
  LEGALLY_INSIGNIFICANT_STATEMENT_STARTS_FROM = 'LEGALLY_INSIGNIFICANT_STATEMENT_STARTS_FROM',
  REASON_LAST_CONDUCTED_KNM_DATE_VALIDATION_4_1_54_STARTS_FROM = 'REASON_LAST_CONDUCTED_KNM_DATE_VALIDATION_4_1_54_STARTS_FROM',
  ENABLED_PERMITTED_DOC_481_4_1_5_STARTS_FROM = 'ENABLED_PERMITTED_DOC_481_4_1_5_STARTS_FROM',
  FIELDS_MARKS_481_4_1_14 = 'FIELDS_MARKS_481_4_1_14',
  TRANSFERRING_AUTHORITIES_4_1_22_STARTS_FROM = 'TRANSFERRING_AUTHORITIES_4_1_22_STARTS_FROM',
  DECISION_4_1_33_EVENTS_START_FROM = 'DECISION_4_1_33_EVENTS_START_FROM',
  KNM_VALIDATION_523_4_1_44_STARTS_FROM = 'KNM_VALIDATION_523_4_1_44_STARTS_FROM',
  SHOW_CHECK_RESULT_MESSAGE_523_4_1_17 = 'SHOW_CHECK_RESULT_MESSAGE_523_4_1_17',
  ERVK_PROSECUTOR_ORGANIZATION_4_1_15_STARTS_FROM = 'ERVK_PROSECUTOR_ORGANIZATION_4_1_15_STARTS_FROM',
  ERVK_PARAM_TABLES_4_1_23_STARTS_FROM = 'ERVK_PARAM_TABLES_4_1_23_STARTS_FROM',
  COLLABORATION_KNO_ERVK_SEARCH_4_1_1 = 'COLLABORATION_KNO_ERVK_SEARCH_4_1_1',
  KNM_VALIDATION_523_4_1_53_STARTS_FROM = 'KNM_VALIDATION_523_4_1_53_STARTS_FROM',
  PASSPORT_AUTOSAVE = 'PASSPORT_AUTOSAVE',
  PASSPORT_AUTOSAVE_PERIOD_MINUTES = 'PASSPORT_AUTOSAVE_PERIOD_MINUTES',
  ERP_NEW_FIELDS_FZ68_4_1_36 = 'ERP_NEW_FIELDS_FZ68_4_1_36',
  KNM_VALIDATION_523_4_1_24_STARTS_FROM = 'KNM_VALIDATION_523_4_1_24_STARTS_FROM',
  REMINDER_DAYS_BEFORE_DEADLINE_PLAN = 'REMINDER_DAYS_BEFORE_DEADLINE_PLAN',
  ENABLED_PAPERLESS_PASSPORT_4_1_3_STARTS_FROM = 'ENABLED_PAPERLESS_PASSPORT_4_1_3_STARTS_FROM',
  ENABLED_PAPERLESS_PASSPORT_ACT_PRESCRIPTION = 'ENABLED_PAPERLESS_PASSPORT_ACT_PRESCRIPTION',
  USE_REMOTE_MONITORING_PM_4_1_1_STARTS_FROM = 'USE_REMOTE_MONITORING_PM_4_1_1_STARTS_FROM',
  COS_IDENTIFIERS_2025_4_1_2 = 'COS_IDENTIFIERS_2025_4_1_2',
  PLAN_SIGNER_166_4_1_4_START_FROM = 'PLAN_SIGNER_166_4_1_4_START_FROM',
  DECISION_SUBJECT_TYPE_4_1_1_START_FROM = 'DECISION_SUBJECT_TYPE_4_1_1_START_FROM',
  KNM_VALIDATION_105_166_25_4_1_16_STARTS_FROM = 'KNM_VALIDATION_105_166_25_4_1_16_STARTS_FROM',
  KNM_VALIDATION_105_166_25_4_1_30_STARTS_FROM = 'KNM_VALIDATION_105_166_25_4_1_30_STARTS_FROM',
  KNM_EVIDENCE_4_1_25_STARTS_FROM = 'KNM_EVIDENCE_4_1_25_STARTS_FROM',
  ENABLED_KNO_VALIDATION_SIGNING = 'ENABLED_KNO_VALIDATION_SIGNING',
  IMMEDIATE_TEST_PURCHASE_DAYS = 'IMMEDIATE_TEST_PURCHASE_DAYS',
  ADMIN_SETTING_HIDE_FIELDS_4_1_29 = 'ADMIN_SETTING_HIDE_FIELDS_4_1_29',
  ENABLED_PM_FOR_ERP_4_1_19 = 'ENABLED_PM_FOR_ERP_4_1_19',
  NPA_VALIDATION_ERVK_ROT_4_1_24_STARTS_FROM = 'NPA_VALIDATION_ERVK_ROT_4_1_24_STARTS_FROM',
  NPA_VALIDATION_ERVK_ROT_4_1_24_KNM_STARTS_FROM = 'NPA_VALIDATION_ERVK_ROT_4_1_24_KNM_STARTS_FROM',
  SETTING_HIDE_FIELDS_4_1_29 = 'SETTING_HIDE_FIELDS_4_1_29',
  SHOW_ANALYTICS_CHAPTER = 'SHOW_ANALYTICS_CHAPTER',
  VALIDATE_PLACES_REGION = 'VALIDATE_PLACES_REGION',
  DATE_VALIDATION_4_1_34_STARTS_FROM = 'DATE_VALIDATION_4_1_34_STARTS_FROM',
  PM_LIMITATION_OF_SUSPENSION_STARTS_FROM = 'PM_LIMITATION_OF_SUSPENSION_STARTS_FROM',
  ERP_KIND_VALIDATION = 'ERP_KIND_VALIDATION',
  ADD_NEW_SIGNER_199_4_1_6_STARTS_FROM = 'ADD_NEW_SIGNER_199_4_1_6_STARTS_FROM',
}
